import pillars from './pillars.js';

const storyList = [pillars,]

export default storyList;